class stepMiniPedagogicalApproachController {

}

export default stepMiniPedagogicalApproachController;


// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepMiniPedagogicalApproach/stepMiniPedagogicalApproachController.js